// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import Element from 'element-ui'
import qs from 'qs'
import 'element-ui/lib/theme-chalk/index.css'
import Vant, { Lazyload } from 'vant';
import 'vant/lib/index.css';

// 引入插件和语言包
import i18n from './i18n/i18n'

Vue.use(Vant)
Vue.use(Lazyload);
Vue.use(Element,{ size: 'small', zIndex: 3000 })
Vue.prototype.qs = qs
Vue.prototype.$axios = axios
axios.defaults.headers['Content-Type'] = 'application/json'
axios.defaults.baseURL = ''
Vue.config.productionTip = false

//var vConsole = new VConsole();
//路由守卫
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  //next()
  if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限
    if (localStorage.getItem('xx')) {  // 获取当前的token和uid是否存在
      next();
    }
    else {

    }
  }
  else {
    next();
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js